import React from "react";
import { useRequest } from "ahooks";
import { Button, ButtonProps } from "antd";

const AutoLoadingButton: React.FC<ButtonProps> = function (props) {
  const { onClick, loading } = props;

  const { run: localOnClick, loading: localLoading } = useRequest(
    async (e: React.MouseEvent<HTMLElement, MouseEvent>) => {
      return await onClick(e);
    },
    {
      manual: true,
    }
  );

  return <Button {...props} onClick={localOnClick} loading={localLoading || loading} />;
};

export default AutoLoadingButton;
